import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGh = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 450 300", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 450, height: 300, fill: "#006b3f" }), /* @__PURE__ */ React.createElement("rect", { width: 450, height: 200, fill: "#fcd116" }), /* @__PURE__ */ React.createElement("rect", { width: 450, height: 100, fill: "#ce1126" }), /* @__PURE__ */ React.createElement("path", { d: "M225,100 257.492,200 172.427,138.197H277.573L192.508,200z", fill: "#000" }));
const ForwardRef = forwardRef(SvgGh);
const Memo = memo(ForwardRef);
export default Memo;
